import React, { Component } from "react";
import TacForm from "../components/form";
import { HashLink as Link } from "react-router-hash-link";
import { reviewdata } from "../data/reviews";
import { upcomingevents } from "../data/upcominge";
import scrollToTop from "../components/scrolltoTop";
import scrollWithOffset from "../components/scrollWithOffset";
import { Calendar, Clock, LocationPin, MoneyBill } from "../constants/icons";

export default class EventsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: "",
        email: "",
        message: "",
      },
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };

  render() {
    const { formData } = this.state;
    const fields = [
      {
        name: "name",
        label: "Name",
        type: "text",
        required: true,
        autoComplete: "name",
      },
      {
        name: "email",
        label: "Email",
        type: "email",
        required: true,
        autoComplete: "email",
      },
      {
        name: "message",
        label: "Message",
        type: "textarea",
        required: true,
        autoComplete: "message",
      },
    ];

    return (
      <>
        <div className="eventspage-container">
          <section className="events-page-hero" id="hero">
            <div className="dherobg"></div>
            <div className="events-page-content">
              <h1>
                Experience the <br />
                afrocollective
              </h1>
              <img
                src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/heroTablet.webp"
                className="t-hero-img"
                alt=""
                fetchpriority="high"
              ></img>
              <p>
                Get tickets to our upcoming events <br />
                and Relive previous events through our galleries.
              </p>
              <div className="events-hero-btns">
                <Link to="/gallery" onClick={scrollToTop}>
                  <button className="prev-event">Previous Events</button>
                </Link>
                <Link to="/events#upcomingevents" scroll={scrollWithOffset}>
                  <button className="upc">Upcoming Events</button>
                </Link>
              </div>
            </div>
          </section>
          <section className="interlude-section">
            <div className="events-imgs-interlude">
              <div className="d-row1 ">
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage1.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage2.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage3.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage4.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage5.webp"
                  alt=""
                />
              </div>
              <div className="d-row2">
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage6.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage7.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage8.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage9.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage11.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage10.webp"
                  alt=""
                />
              </div>
              <div className="t-row1">
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage1.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage2.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage3.webp"
                  alt=""
                />
              </div>
              <div className="t-row2">
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage4.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage5.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage9.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage10.webp"
                  alt=""
                />
              </div>
              <div className="t-row3">
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage6.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage7.webp"
                  alt=""
                />
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/InterludeImage8.webp"
                  alt=""
                />
              </div>
            </div>
          </section>
          <section className="upcoming-events" id="upcomingevents">
            <img
              className="leaves small-leaves small-right-leaves"
              src="https://d1g9iww9o5ioh1.cloudfront.net/leaves/rightSmallLeaves.webp"
              alt=""
            />
            <h3>Upcoming events</h3>
            <div className="upcoming-events-container">
              {upcomingevents
                .filter((event) => {
                  const [day, month, year] = event.date.split("/");
                  const eventDate = new Date(`${year}-${month}-${day}`);
                  const today = new Date();
                  today.setHours(0, 0, 0, 0); // remove time portion
                  return eventDate >= today;
                })
                .sort((a, b) => {
                  const [aday, amonth, ayear] = a.date.split("/");
                  const [bday, bmonth, byear] = b.date.split("/");
                  const adate = new Date(`${ayear}-${amonth}-${aday}`);
                  const bdate = new Date(`${byear}-${bmonth}-${bday}`);
                  return adate - bdate;
                })
                .map((event) => (
                  <div className="upc-event" key={event.id}>
                    <div className="img-container">
                      <img src={event.image} alt={event.title} />
                    </div>
                    <div className="main-event">
                      <h4 className="upc-event-title">{event.title}</h4>
                      <div className="upc-event-details">
                        <div className="event-detail">
                          <span className="icon-span">
                            <Calendar className="icon" />
                          </span>
                          <span className="event-detail">{event.date}</span>
                        </div>
                        <div className="event-detail">
                          <span className="icon-span">
                            <Clock className="icon" />
                          </span>
                          <span>{event.time}</span>
                        </div>
                        <div className="event-detail">
                          <span className="icon-span">
                            <LocationPin className="icon" />
                          </span>
                          <span>{event.address}</span>
                        </div>
                        <div className="event-detail">
                          <span className="icon-span">
                            <MoneyBill className="icon" />
                          </span>
                          <span>{event.price}</span>
                        </div>
                      </div>

                      {event.link ? (
                        <a
                          href={event.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button>Get Tickets</button>
                        </a>
                      ) : (
                        <button
                          disabled
                          style={{ opacity: 0.5, cursor: "not-allowed" }}
                        >
                          Tickets Coming Soon
                        </button>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </section>
          <section className="reviews" id="reviews">
            <h3>Reviews</h3>
            <div className="reviews-container">
              {reviewdata.map((review) => (
                <div className="review" key={review.id}>
                  <div className="review-extras">
                    <span>{review.image}</span>
                    <div className="name-rating">
                      <h4 className="name">{review.name}</h4>
                      <div className="rating">{review.rating}</div>
                    </div>
                  </div>
                  <span className="review-content">{review.content}</span>
                </div>
              ))}
            </div>
          </section>
          <section id="eventsform" className="events-form-section form">
            <TacForm
              fields={fields}
              formid="Review"
              first="Get in touch"
              second="Have you been to one of our events before?"
              third="Tell us about your experience!"
              formData={formData}
              onChange={this.handleChange}
            />
            <div className="form-img-container">
              <img
                src="https://d1g9iww9o5ioh1.cloudfront.net/events_page/form.webp"
                className="form-img"
                alt="events-form-img"
              />
            </div>
          </section>
        </div>
      </>
    );
  }
}
